import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Row, Col } from 'react-flexbox-grid'
import { DataTable } from 'components/DataTable'
import { Modal } from 'components/Modal'
import { Form, Text } from 'components/forms'
import Button from 'components/Button'
import { objectCheck } from '../DeviceUpdate/DeviceUpdate'
import UpdateGlobalCR from '../../gql/updateGlobalCR'
import { useMutation, useQuery } from 'components/graphql'
import { StyledField } from 'components/TagEditor/styled'
import Divider from 'components/Divider'
import appConfig from 'gql/query/appConfig'

const columns = t => [
	{
		accessor: 'number',
		Header: t('common.fields.code'),
		width: 100
	}, {
		accessor: 'value',
		Header: t('common.fields.name')
	}
]

const KitchenLocation = () => {
	const [mutateData, setMutateData] = useState(null)
	const [isEmptyMutateData, setIsEmptyMutateData] = useState(false)
	const [updateAppConfig] = useMutation(UpdateGlobalCR.printerLocations)
	const [t] = useTranslation()
	const { data: configData } = useQuery(appConfig.printerLocations, {
		fetchPolicy: 'cache-and-network'
	})
	const allSlots = configData?.getAppConfig?.cashRegisterGlobal?.printerLocations || []
	const copyAllSlots = JSON.parse(JSON.stringify(allSlots))
	const tableData = copyAllSlots.sort((a, b) => a.value.localeCompare(b.value)).filter((item, i) => {
		if(item.value) {
			item.number = i + 1
		}
		return item
	})
	useEffect(() => {
		setIsEmptyMutateData(objectCheck(mutateData))
	}, [mutateData])
	function handleSubmit({ value }) {
		const trimmedValue = value && value.trim()
		let updatePrinters = []
		let fullListPrinters = allSlots.reduce((acc, printer) => {
			if(printer.value) {
				acc[printer.dbIndex] = printer
			}
			return acc
		}, [])
		if(isEmptyMutateData) {
			updatePrinters = fullListPrinters.map(printer => {
				if(printer.dbIndex === mutateData.dbIndex) {
					printer.value = trimmedValue
				}
				return printer.value || null
			})
		}
		if(!isEmptyMutateData && trimmedValue) {
			if(fullListPrinters.length < 9) {
				updatePrinters = [...fullListPrinters, { value: trimmedValue }]
			} else {
				const emptyIndex = fullListPrinters.findIndex(printer => !printer)
				updatePrinters = [...fullListPrinters]
				updatePrinters.splice(emptyIndex, 1, { value: trimmedValue })
			}
			updatePrinters = updatePrinters.map(printer => printer ? printer.value : null)
		}
		updatePrinters && updateAppConfig({
			variables: {
				fields: {
					cashRegisterGlobal: {
						printerLocations: updatePrinters
					}
				}
			}
		})
		setMutateData(null)
	}
	function handleSelect(state, { original }) {
		setMutateData(original)
	}
	function nameValidate(value) {
		const isEmptyValidateData = objectCheck(mutateData)
		const emptyIndex = allSlots.findIndex(printer => !printer)
		const val = value && value.trim()
		if(!val && !isEmptyValidateData) {
			return t('validators.required')
		}
		if(!isEmptyValidateData && emptyIndex < 0 && allSlots.length === 9) {
			return t('validators.required_count')
		}
		const isExisting = tableData.find(({ value: name }) => name === val)
		return isExisting ? t('validators.duplicate') : null
	}

	return(
		<>
			<Row>
				<Col xs={6}>
					<DataTable
						data={tableData}
						columns={columns(t)}
						onAddRecord={() => setMutateData({})}
						onRowClick={handleSelect}
						sortable={false}
						resizable={false}
					/>
				</Col>
			</Row>
			{mutateData &&
				<Modal unmount={() => setMutateData(null)} label={t(!isEmptyMutateData ? 'common.strings.new_kitchen_location' : 'common.strings.changing_kitchen_location')} width={500}>
					<Form
						initialValues={mutateData}
						onSubmit={handleSubmit}
					>
						<StyledField>
							<Text
								field='value'
								label={t('common.fields.name')}
								validate={nameValidate}
								validateOnChange
							/>
						</StyledField>
						<Divider/>
						<Button text={t('common.buttons.apply')} type='submit' />
					</Form>
				</Modal>
			}
		</>
	)
}

export default KitchenLocation
